export const ELEMENT_VOCAB_FLOW = 'vocab-flow';
